import React, { useState, useFocusEffect, useEffect, InputHTMLAttributes, label, form } from 'react';
import store from './redux/store.js';
import * as actions from './redux/actions.js'
import { APIvar } from '../services/variables.js';
import { redirect } from "react-router-dom";
import { useSelector, useDispatch } from 'react-redux';
import './login.css'
import { APICall } from './services/api.service.js';
import {ReactComponent as UserIcon} from '../images/icons/person-circle.svg';
import {ReactComponent as RegisterIcon} from '../images/icons/register.svg';
import {ReactComponent as ResetPasswordIcon} from '../images/icons/reset-password.svg';
import Logo from "../images/logo_atlas.png";


import { FiUser } from "react-icons/fi";
import { FiLock } from "react-icons/fi";


const useColor = APIvar.colorUse;
const backColor = APIvar.colorBackground;



const ChangePassword = () => {
    const dispatch = useDispatch()
    const [registrationEmail, setRegistrationEmail] = useState("");
    const [registrationPassword, setRegistrationPassword] = useState("");
    const [registrationRepeatPassword, setRRegistrationRepeatPassword] = useState("")
    const [loginEmail, setLoginEmail] = useState("");
    const [loginPassword, setLoginPassword] = useState("");
    const [isLoginVisible, setIsLoginVisible] = useState(true);
    const [isRegisterVisible, setIsRegisterVisible] = useState(false)
    const [showLogIn, setShowLogIn] = useState(true)
    const [showRegister, setShowRegister] = useState(false)
    const [showResetPassword, setShowResetPassord] = useState(false);

    const [privacyIsOpen, setPrivacyIsOpen] = useState(false);
    const [userDataIsOpen, setUserDataIsOpen] = useState(false);

    const [viewSignIn, setViewSignIn] = useState(false);
    useEffect(()=>{
       
    },[])

    const handleRegistration = (e) => {
        e.preventDefault()
        console.log("registration")
    }

    const handleLogin = (e) => {
        e.preventDefault();
        //samo me prijavi

        
       APICall(
           '/changePassword',
           {
                user: loginEmail,
                pass: loginPassword,
                platform: '0',
                version:'1.0'

            }).then((response=> {
                console.log(response)
                
                
            }))
            
    }

    return (
        <div className="login-registration">
            
            <div className="login-registration-tab">
                <div className="select-login" style={{backgroundColor: isLoginVisible? "#93aece": "unset"}}  onClick={()=> {
                    setIsLoginVisible(true)
                    setIsRegisterVisible(false)
                }}>
                    <UserIcon className="select-login-icon"/>
                </div>
                


            </div>

            <div className="login-registration-container">

                <div className="login-registration-logo-container">
                    <img src={Logo} alt="Logo" className="login-registration-logo"/>
                  
                </div>

                <div className="login-registration-form">
                    <div className="login-page" style={{ display: isLoginVisible? "unset" : "none" }}>


                        
                        <form className="login-page-form" onSubmit={(e)=>{handleLogin(e)}}>
                            <div className="inputContainer">
                                <FiUser className="ikona"/>
                                <input
                                        className="emailInputLogin"
                                        type='text'
                                        placeholder="user"  
                                        onChange={e => {
                                            setLoginEmail(e.target.value)
                                        }}
                                />
                            </div>

                            <div className="inputContainer">
                                        <FiLock className="ikona"/>
                                        
                                        <input
                                            className="passwordInputLogin"
                                            type='password'
                                            placeholder="new password"  
                                            onChange={e => {

                                                setLoginPassword(e.target.value)
                                            }}
                                        />
                            </div>
                    
                                
  
                                


                            <div className="submitLogin">
                                <button type="submit" className='buttonLogIn'>Prijava</button>
                                            
                            </div>

                            </form>
                        


                    </div>

                    <div className="registration-page" style={{ display: isRegisterVisible? "unset" : "none" }}>


                            <form className="registration-page-form" onSubmit={()=>{handleRegistration()}}>
                               
                               
                                            <div className="inputContainer">
                                                    <FiUser className="ikona"/>
                                                    <input
                                                            className="emailInput"
                                                            type='text'
                                                            placeholder="Unesite e-mail"  
                                                            onChange={e => {
                                                                setRegistrationEmail(e.target.value)
                                                            }}
                                                    />
                                            </div>        

                                            <div className="inputContainer">
                                                    <FiLock className="ikona"/>
                                                    
                                                    <input
                                                        className="emailInput"
                                                        type='password'
                                                        placeholder="Unesite novu lozinku"  
                                                        onChange={e => {
                                                            setRegistrationPassword(e.target.value);
                                                            }}
                                                    />
                                                    
                                            </div>
                                            <div className="inputContainer">
                                                    <FiLock className="ikona"/>
                                                    <input
                                                        className="emailInput"
                                                        type='password'
                                                        placeholder="Ponovite novu lozinku"  
                                                        onChange={e => {
                                                            setRRegistrationRepeatPassword(e.target.value)
                                                            }}
                                                    />
                                            </div>        
                            
                                            <div className="submitRegistration">

                                                <button type="submit" className='buttonRegistration'>Prijava</button>
                                            </div>

                                

                                
                            </form>
                        
                    </div>
                </div>
            </div>
            



        </div>
    );
};

export default ChangePassword;
